import { Component, computed, effect, inject, input, Input, signal } from '@angular/core'
import { PricingRowVM } from '../vetcor-pricing-row.model'
import { VetcorPricingRowService } from '../vetcor-pricing-row.service'
import { BsModalService } from 'ngx-bootstrap/modal'
import { Subject } from 'rxjs'
import { sign } from 'crypto'
import { AuthManager } from 'src/app/shared/auth/AuthManager'
import { HospitalPricingService } from '../../hospital-pricing.service'

class ActionsVM {
   canEditPrice = false
   canRequestPrice = false
   canApprovePrice = false
   undoAction: () => void
}

@Component({
   selector: 'vetcor-pricing-action-buttons',
   templateUrl: './vetcor-pricing-action-buttons.component.html',
   styleUrls: ['./vetcor-pricing-action-buttons.component.scss'],
   standalone: false,
})
export class VetcorPricingActionButtonsComponent {
   isCaptain = input<boolean>(false)
   row = input<PricingRowVM>()
   actions = signal<ActionsVM>(new ActionsVM())
   hospitalPricingService = inject(HospitalPricingService)

   /*
   CAN RESET PRICE:
   (vmRow.isProductSaved(productRow?.id) ||
            productRow?.opsPrice > 0 ||
            vmRow.isProductApproved(productRow?.id) ||
            vmRow.isProductRejected(productRow?.id)) &&
         isCaptain &&
         productRow?.canUpdatePrice != 0 &&
         (productRow?.opsPrice > 0 || productRow?.captainApproved == 2)

   ANOTHER VERSION OF RESET PRICE:
   !row().isEditing &&
         vmRow.isProductSaved(productRow?.id) &&
         !vmRow.isProductApproved(productRow?.id) &&
         !vmRow.isProductRejected(productRow?.id) &&
         !isCaptain &&
         productRow?.canUpdatePrice != 0 &&
         productRow?.opsPrice <= 0 &&
         productRow?.newPrice > 0
   */

   constructor(private pricingRowService: VetcorPricingRowService, private modalService: BsModalService) {
      effect(() => {
         const row = this.row()
         const newActions: ActionsVM = new ActionsVM()

         if (row.isEditing) {
            newActions.canEditPrice = false
            newActions.canRequestPrice = false
         }

         if (!this.row().changeType && !!this.row().canUpdatePrice && !this.row().isEditing) {
            newActions.canRequestPrice = true
         }

         if (this.row().changeType === 'Cycle') {
            if ([0, 1].includes(this.hospitalPricingService.activeCycle().batchStatus)) {
               newActions.canEditPrice = true
            }
         }

         if (!this.isCaptain && this.row().approvalStatus == 'Pending' && !this.row().isEditing) {
            if (this.row().changeType === 'Practice') {
               newActions.undoAction = () => this.pricingRowService.undoPracticePricingChangeRequest(this.row())
            }
         }

         if (this.isCaptain && this.row().approvalStatus == 'Pending') {
            newActions.canApprovePrice = true
         }

         this.actions.set(newActions)
      })
   }

   onSave() {
      if (this.row().isSaving) {
         return
      }

      if (!this.row().changeType) {
         this.pricingRowService.requestNewPrice(this.row())
      } else if (this.isCaptain()) {
         this.pricingRowService.savePricingOps(this.row())
      } else {
         this.pricingRowService.savePricing(this.row(), this.isCaptain())
      }
      // else if ()

      /*
      const apiCall = this.isCaptain
         ? this.pricingRowService.savePricingOps(this.productRow, this.passedScheduleDate)
         : this.pricingRowService.savePricing(this.productRow, this.passedScheduleDate, this.isCaptain)
*/
   }

   onApprovePriceClick(event: any) {
      event.stopPropagation()
      this.pricingRowService.approve(this.row())
   }

   onRejectPriceClick(event: any) {
      event.stopPropagation()
      this.pricingRowService.reject(this.row(), this.row().finalComment || '')
   }

   onUndoClick(event: any) {
      event.stopPropagation()
      this.actions().undoAction()
   }

   onCancelClick(event: any): void {
      event.stopPropagation()
      this.pricingRowService.toggleEditing(this.row())
   }

   onMoreDetailsClick(event: any): void {
      event.stopPropagation()
      this.pricingRowService.openDetails(this.modalService, this.row(), this.row().changeType === 'Practice', this.isCaptain())
   }

   toggleEdit(event: any): void {
      event.stopPropagation()
      this.pricingRowService.toggleEditing(this.row())
   }
}
